export default {
    CARD: 'card',
  }